import './Mission.css'

const Mission = () => {
    return (
        <div>
            <div className='mission'>
                <div className="mission-top">
                    <div className='mission-heading' data-aos="fade-up"
                        data-aos-duration="1000">
                        <h2>our mission</h2>
                        <hr />
                    </div>
                    <div className='mission-content' data-aos="fade-up"
                        data-aos-duration="1000">
                        <h4>
                            An Extraordinary Living Experience
                        </h4>
                        <p>
                            Our mission is to develop premium residential and commercial projects that combine refined
                            architecture, disciplined project management, reliable construction standards.
                            We believe to deliver every project with trust, quality, and timely delivery
                        </p>
                    </div>
                </div>
                <div className="mission-bottom" data-aos="fade-up"
                    data-aos-duration="1000">
                    <div className="mission-bottom-img">
                        <img src="./HomePhotos/Mission/1.jpg" alt="Our mission pic" />
                        <img src="./HomePhotos/Mission/2.jpg" alt="Our mission pic" />
                        <img src="./HomePhotos/Mission/3.jpg" alt="Our mission pic" />
                        <img src="./HomePhotos/Mission/4.jpg" alt="Our mission pic" />
                        <img src="./HomePhotos/Mission/5.jpg" alt="Our mission pic" />
                        <img src="./HomePhotos/Mission/6.jpg" alt="Our mission pic" />
                        <img src="./HomePhotos/Mission/7.jpg" alt="Our mission pic" />
                        <img src="./HomePhotos/Mission/8.jpg" alt="Our mission pic" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Mission